module.exports = __webpack_public_path__ + "static/media/elements_line_start_vertical.6ed2ef61.svg";